import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SITE_CONFIG } from '../config';
import './AgentReferral.css';

const AgentReferral = () => {
  const [formData, setFormData] = useState({
    submitting_agent_name: '',
    submitting_agent_email: '',
    prospective_agent_name: '',
    prospective_agent_email: '',
    prospective_agent_phone: ''
  });
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingReferrals, setLoadingReferrals] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const navigate = useNavigate();

  useEffect(() => {
    fetchReferrals();
  }, []);

  useEffect(() => {
    document.body.classList.remove('intro-active');
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
    };
  }, []);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: 'success' }), 3000);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const submitReferral = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://tophamtechbeb.com/api/toptech/onboarding/v1/agent-referral', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': 'treas-api-key-2025'
        },
        body: JSON.stringify({
          ...formData,
          submitting_agent_site_id: SITE_CONFIG.SITE_ID
        })
      });

      if (response.ok) {
        showToast('Agent referral submitted successfully!', 'success');
        setFormData({
          submitting_agent_name: '',
          submitting_agent_email: '',
          prospective_agent_name: '',
          prospective_agent_email: '',
          prospective_agent_phone: ''
        });
        fetchReferrals();
      } else {
        showToast('Error submitting referral. Please try again.', 'error');
      }
    } catch (error) {
      showToast('Network error submitting referral.', 'error');
    }

    setLoading(false);
  };

  const fetchReferrals = async () => {
    setLoadingReferrals(true);
    try {
      const response = await fetch(`https://tophamtechbeb.com/api/toptech/onboarding/v1/get-agent-referrals?site_id=${SITE_CONFIG.SITE_ID}`, {
        headers: { 'X-API-Key': 'treas-api-key-2025' }
      });

      if (response.ok) {
        const result = await response.json();
        setReferrals(Array.isArray(result.data) ? result.data : []);
      }
    } catch (error) {
      console.error('Error fetching referrals:', error);
    }
    setLoadingReferrals(false);
  };

  return (
    <div className="agent-referral">
      <div className="referral-header">
        <h1>Agent Referral</h1>
        <button onClick={() => navigate('/admin')} className="back-button">
          ← Back to Admin
        </button>
      </div>

      <div className="referral-content">
        <div className="referral-form-section">
          <h2>Refer an Agent</h2>
          <form onSubmit={submitReferral} className="referral-form">
            <div className="form-row">
              <div className="form-group">
                <label>Your Name</label>
                <input
                  type="text"
                  name="submitting_agent_name"
                  value={formData.submitting_agent_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Your Email</label>
                <input
                  type="email"
                  name="submitting_agent_email"
                  value={formData.submitting_agent_email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Prospective Agent Name</label>
                <input
                  type="text"
                  name="prospective_agent_name"
                  value={formData.prospective_agent_name}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="form-group">
                <label>Prospective Agent Email</label>
                <input
                  type="email"
                  name="prospective_agent_email"
                  value={formData.prospective_agent_email}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Prospective Agent Phone</label>
                <input
                  type="tel"
                  name="prospective_agent_phone"
                  value={formData.prospective_agent_phone}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <button type="submit" disabled={loading} className="submit-btn">
              {loading ? 'Submitting...' : 'Submit Referral'}
            </button>
          </form>
        </div>

        <div className="referrals-list-section">
          <div className="referrals-header">
            <h2>Your Referrals</h2>
            <button onClick={fetchReferrals} className="refresh-btn">
              🔄 Refresh
            </button>
          </div>

          {loadingReferrals ? (
            <div className="loading">Loading referrals...</div>
          ) : referrals.length > 0 ? (
            <div className="referrals-grid">
              {referrals.map((referral, index) => (
                <div key={index} className="referral-card">
                  <div className="referral-info">
                    <h3>{referral.prospective_agent_name}</h3>
                    <p className="referral-email">{referral.prospective_agent_email}</p>
                    <p className="referral-phone">{referral.prospective_agent_phone}</p>
                  </div>
                  <div className="referral-date">
                    {new Date(referral.date_submitted).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-referrals">
              No referrals submitted yet.
            </div>
          )}
        </div>
      </div>

      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default AgentReferral;